"use client"

import { Piano } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PianoIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PianoIcon = component(Icon)({ as: Piano })
